export interface ServiceFeature {
  icon: string;
  title: string;
  desc: string;
}

export interface ServiceData {
  slug: string;
  title: string;
  shortTitle: string;
  icon: string;
  tagline: string;
  heroImg: string;
  heroPosition?: string;
  sideImg: string;
  description: string;
  longDesc: string;
  features: ServiceFeature[];
  gallery: { img: string; label: string; position?: string }[];
  metaDesc: string;
}

const SERVICES_DATA: ServiceData[] = [
  {
    slug: "reklam-tabela",
    title: "Reklam Tabela",
    shortTitle: "Reklam Tabela",
    icon: "ri-advertisement-line",
    tagline: "Işıklı ve ışıksız tabela çözümleriyle markanızı öne çıkarın",
    heroImg: "/images/totemt/t.webp",
    sideImg: "/images/kharft/b1-8.webp",
    description: "Işıklı tabela, ışıksız tabela, kutu harf, totem ve yönlendirme sistemlerinde işletmenize özel üretim ve montaj hizmeti sunuyoruz.",
    longDesc: "VİP Reklam Dekorasyon olarak reklam tabela alanında konsept geliştirme, ölçülendirme, üretim ve sahada montajı tek ekipte yürütüyoruz. Kutu harf ışıklı tabela, totem tabela, inşaat tabelası, klinik tabela, eczane tabelası, yönlendirme tabelası ve özel tasarım tabela çözümlerini işletmenizin konumu ve görünürlük ihtiyacına göre planlıyoruz.",
    features: [
      { icon: "ri-lightbulb-line", title: "Işıklı Tabela", desc: "Gece görünürlüğünü artıran LED destekli tabela çözümleri" },
      { icon: "ri-text-spacing", title: "Kutu Harf Işıklı Tabela", desc: "Kurumsal kimliğe uygun paslanmaz ve akrilik harf sistemleri" },
      { icon: "ri-layout-column-line", title: "Totem Tabela", desc: "Cadde ve yol akslarında uzaktan fark edilen totem uygulamaları" },
      { icon: "ri-signpost-line", title: "Yönlendirme Tabelası", desc: "AVM, tesis ve kurumlar için iç-dış yönlendirme çözümleri" },
      { icon: "ri-community-line", title: "Kurum Tabelaları", desc: "Klinik, eczane, apartman ve iş güvenliği tabelaları" },
      { icon: "ri-tools-line", title: "Üretim + Montaj", desc: "Tasarımdan montaja kadar uçtan uca tek ekip yönetimi" },
    ],
    gallery: [
      { img: "/images/kharft/6-1.webp", label: "Kutu Harf Işıklı Tabela" },
      { img: "/images/totemt/2.webp", label: "Kurumsal Totem Tabela" },
      { img: "/images/d/d-6.webp", label: "Dış Cephe Reklam Tabelası" },
    ],
    metaDesc: "Osmaniye reklam tabela hizmetleri - ışıklı/ışıksız tabela, kutu harf, totem ve yönlendirme tabela çözümleri. VİP Reklam Dekorasyon.",
  },
  {
    slug: "isikli-tabela",
    title: "Işıklı Tabela",
    shortTitle: "Işıklı Tabela",
    icon: "ri-lightbulb-line",
    tagline: "Gece-gündüz güçlü görünürlük sunan LED ışıklı tabela çözümleri",
    heroImg: "/images/it/AD%C4%B0DAS%20AVM%20I%C5%9EIKLI%20TABELA.webp",
    sideImg: "/images/it/IMG_20210702_202942.webp",
    description: "Işıklı tabelalar, işletmenizin özellikle akşam saatlerinde fark edilmesini sağlayan en etkili reklam çözümlerindendir.",
    longDesc: "VİP Reklam Dekorasyon olarak LED modül, pleksi, kompozit ve kutu harf kombinasyonlarıyla uzun ömürlü ışıklı tabela üretimi yapıyoruz. Konum analizi, ölçülendirme, elektrik altyapısı planlaması, üretim ve montaj süreçlerinin tamamını tek ekipte yöneterek hem estetik hem performans odaklı uygulamalar sunuyoruz.",
    features: [
      { icon: "ri-lightbulb-flash-line", title: "LED Aydınlatma", desc: "Düşük tüketimli, yüksek parlaklıklı LED çözümleri" },
      { icon: "ri-moon-clear-line", title: "Gece Görünürlüğü", desc: "Akşam saatlerinde güçlü okunabilirlik" },
      { icon: "ri-shield-check-line", title: "Dış Mekan Dayanımı", desc: "UV ve hava koşullarına dayanıklı malzeme" },
      { icon: "ri-tools-line", title: "Profesyonel Montaj", desc: "Güvenli elektrik altyapısı ve düzgün montaj" },
      { icon: "ri-palette-line", title: "Kurumsal Tasarım", desc: "Marka kimliğine özel renk ve form tasarımı" },
      { icon: "ri-timer-line", title: "Uzun Ömür", desc: "Yüksek kalite bileşenlerle dayanıklı kullanım" },
    ],
    gallery: [
      { img: "/images/it/AD%C4%B0DAS%20AVM%20I%C5%9EIKLI%20TABELA.webp", label: "AVM Işıklı Tabela Uygulaması" },
      { img: "/images/it/IMG_20210302_185833.webp", label: "Kurumsal LED Tabela" },
      { img: "/images/it/IMG_20210608_231036.webp", label: "Cephe Işıklı Yazı Çalışması" },
    ],
    metaDesc: "Osmaniye ışıklı tabela çözümleri - LED ışıklı tabela tasarım, üretim ve montaj hizmetleri. VİP Reklam Dekorasyon.",
  },
  {
    slug: "isiksiz-tabela",
    title: "Işıksız Tabela",
    shortTitle: "Işıksız Tabela",
    icon: "ri-contrast-drop-line",
    tagline: "Sade, kurumsal ve güçlü görünüm sunan ışıksız tabela çözümleri",
    heroImg: "/images/iz/IMG_20210716_164725.webp",
    heroPosition: "center 22%",
    sideImg: "/images/iz/IMG_20210629_153943.webp",
    description: "Işıksız tabelalar, özellikle gündüz yoğun müşteri trafiği olan işletmeler için ekonomik ve kurumsal bir çözümdür.",
    longDesc: "Işıksız tabela uygulamalarında doğru malzeme, doğru yazı karakteri ve doğru yerleşim en kritik unsurlardır. VİP Reklam Dekorasyon olarak kompozit zemin, folyo kesim, kabartma harf ve özel taşıyıcı sistemlerle işletmenize uygun ışıksız tabela üretimi gerçekleştiriyoruz.",
    features: [
      { icon: "ri-layout-2-line", title: "Kurumsal Görünüm", desc: "Sade ve güçlü marka algısı oluşturan tasarımlar" },
      { icon: "ri-wallet-3-line", title: "Ekonomik Çözüm", desc: "Aydınlatma olmadan düşük işletme maliyeti" },
      { icon: "ri-shield-star-line", title: "Dayanıklı Malzeme", desc: "Kompozit, galvaniz ve kaliteli yüzey uygulamaları" },
      { icon: "ri-ruler-2-line", title: "Ölçüye Özel Üretim", desc: "Cepheye uygun oranlarda özel imalat" },
      { icon: "ri-brush-3-line", title: "Tipografi Desteği", desc: "Uzak mesafeden okunabilir yazı düzeni" },
      { icon: "ri-tools-line", title: "Uygulama ve Montaj", desc: "Sahada hızlı ve temiz kurulum süreçleri" },
    ],
    gallery: [
      { img: "/images/iz/20190319_152813.webp", label: "Işıksız Tabela Uygulaması" },
      { img: "/images/iz/IMG_20181229_141650.webp", label: "Işıksız Cephe Tabela Uygulaması" },
      { img: "/images/iz/IMG_20210623_170600.webp", label: "Kurumsal Işıksız Yazı Çalışması" },
    ],
    metaDesc: "Osmaniye ışıksız tabela hizmetleri - kurumsal cephe tabelası tasarım, üretim ve montaj çözümleri. VİP Reklam Dekorasyon.",
  },
  {
    slug: "yol-yonlendirme-tabelasi",
    title: "Yol & Yönlendirme Tabelası",
    shortTitle: "Yönlendirme Tabelası",
    icon: "ri-signpost-line",
    tagline: "Kurum, tesis ve kampüs alanları için net ve okunabilir yönlendirme sistemleri",
    heroImg: "/images/y/IMG_20201006_120918.webp",
    sideImg: "/images/y/IMG_20201006_121059.webp",
    description: "Yol ve yönlendirme tabelaları, ziyaretçilerin alan içinde doğru noktaya hızlıca ulaşmasını sağlayan kritik sistemlerdir.",
    longDesc: "VİP Reklam Dekorasyon olarak tesis içi ve dışı yönlendirme çözümlerini keşif aşamasından montaja kadar planlıyoruz. Hastane, okul, fabrika, plaza ve site projelerinde okunabilirlik standartlarına uygun, dayanıklı ve kurumsal yönlendirme tabela sistemleri üretiyoruz.",
    features: [
      { icon: "ri-map-pin-line", title: "Doğru Konumlandırma", desc: "Akışa uygun doğru noktalara yönlendirme yerleşimi" },
      { icon: "ri-article-line", title: "Yüksek Okunabilirlik", desc: "Standartlara uygun ikon, yazı ve ok kullanımı" },
      { icon: "ri-building-line", title: "Kurum İçi Sistem", desc: "Kat planı, blok ve bölüm yönlendirme tabelaları" },
      { icon: "ri-road-map-line", title: "Dış Alan Yönlendirme", desc: "Yol aksı ve otopark yönlendirme çözümleri" },
      { icon: "ri-shield-check-line", title: "Hava Koşuluna Dayanım", desc: "Dış mekana uygun uzun ömürlü malzeme kullanımı" },
      { icon: "ri-tools-line", title: "Anahtar Teslim Kurulum", desc: "Üretim, montaj ve revizyon süreçlerinin yönetimi" },
    ],
    gallery: [
      { img: "/images/totemt/1.webp", label: "Dış Alan Yönlendirme Totemi" },
      { img: "/images/totemt/3.webp", label: "Kurumsal Yönlendirme Uygulaması" },
      { img: "/images/totemt/2.webp", label: "Tesis Giriş Yönlendirme Çözümü" },
    ],
    metaDesc: "Osmaniye yol ve yönlendirme tabelası hizmetleri - kurum içi/dışı yönlendirme sistemleri tasarım, üretim ve montaj çözümleri.",
  },
  {
    slug: "cephe-kaplama",
    title: "Cephe Kaplama",
    shortTitle: "Cephe Kaplama",
    icon: "ri-building-4-line",
    tagline: "Binanızın yüzünü modern bir kimliğe kavuşturun",
    heroImg: "/images/d/d-5.webp",
    sideImg: "/images/d/d-5.webp",
    description: "Alüminyum kompozit, doğaltaş ve modern kaplamalarla binalara estetik ve uzun ömürlü cephe çözümleri sunuyoruz.",
    longDesc: "VİP Reklam Dekorasyon olarak alüminyum kompozit panel, doğaltaş, ahşap görünümlü ve metal kaplamalar başta olmak üzere geniş malzeme yelpazesiyle cephe projelerinizi hayata geçiriyoruz. Hem estetik hem de yalıtım açısından binalarınıza değer katıyoruz. Tüm projelerimizde kaliteli malzeme, deneyimli montaj ekibi ve garanti belgesi sunuyoruz.",
    features: [
      { icon: "ri-shield-check-line", title: "Alüminyum Kompozit Panel", desc: "Hafif, dayanıklı ve uzun ömürlü ACM panel sistemleri" },
      { icon: "ri-leaf-line", title: "Doğaltaş Kaplama", desc: "Granit, mermer ve taş görünümlü yüksek dayanımlı kaplamalar" },
      { icon: "ri-flashlight-line", title: "Metal & Ahşap Kaplama", desc: "Modern görünümlü metal ve dekoratif ahşap cephe sistemleri" },
      { icon: "ri-tools-line", title: "Uzman Montaj", desc: "Deneyimli ekibimizle hızlı ve güvenli montaj" },
      { icon: "ri-award-line", title: "Garanti & Bakım", desc: "Tüm cephe projelerimizde malzeme ve işçilik garantisi" },
      { icon: "ri-draft-line", title: "Tasarım Desteği", desc: "3D görselleştirme ve profesyonel tasarım danışmanlığı" },
    ],
    gallery: [
      { img: "/images/d/d-1.webp", label: "Kompozit Cephe Uygulaması", position: "center 38%" },
      { img: "/images/d/d-6.webp", label: "Kurumsal Dış Cephe Tasarımı", position: "center 45%" },
      { img: "/images/d/d-10.webp", label: "Modern Cephe Kaplama Detayı", position: "center 30%" },
    ],
    metaDesc: "Osmaniye cephe kaplama hizmetleri - alüminyum kompozit, doğaltaş ve metal kaplama sistemleri. VİP Reklam Dekorasyon profesyonel ekibiyle hizmetinizde.",
  },
  {
    slug: "kutu-harf-tabela",
    title: "Kutu Harf Tabela",
    shortTitle: "Kutu Harf",
    icon: "ri-text-spacing",
    tagline: "Markanızı gece gündüz parlatan LED aydınlatmalı tabelalar",
    heroImg: "/images/kharft/b1-8.webp",
    heroPosition: "center 38%",
    sideImg: "/images/kharft/b1-8.webp",
    description: "Paslanmaz çelik, alüminyum ve akrilik malzemelerle LED aydınlatmalı kutu harf tabela üretimi yapıyoruz.",
    longDesc: "Kutu harf tabelalar markanızın en güçlü görsel ifadesidir. VİP Reklam olarak paslanmaz çelik, alüminyum ve akrilik malzemeleri kullanarak içten aydınlatmalı, dıştan aydınlatmalı ve gündüz-gece her koşulda etkili kutu harf tabelalar üretiyoruz. Her boyut ve karmaşıklıkta üretim kapasitemiz mevcuttur.",
    features: [
      { icon: "ri-lightbulb-line", title: "İçten Aydınlatmalı", desc: "Geceleri parlayan, markanızı öne çıkaran LED sistemler" },
      { icon: "ri-sun-line", title: "Dıştan Aydınlatmalı", desc: "Spot ve profil LED ile dramatik tabela ışıklandırması" },
      { icon: "ri-medal-line", title: "Paslanmaz Çelik", desc: "Uzun ömürlü, hava koşullarına dayanıklı çelik harfler" },
      { icon: "ri-paint-brush-line", title: "Akrilik & Renkli", desc: "Her renk ve efektte akrilik kaplama seçenekleri" },
      { icon: "ri-ruler-2-line", title: "Her Boyut", desc: "Küçük dükkan tabelasından büyük bina tabelasına tüm ölçekler" },
      { icon: "ri-recycle-line", title: "Enerji Tasarrufu", desc: "Düşük tüketimli LED teknolojisiyle uzun ömür" },
    ],
    gallery: [
      { img: "/images/kharft/6-1.webp", label: "Paslanmaz Kutu Harf Uygulaması" },
      { img: "/images/kharft/b1-7.webp", label: "LED Aydınlatmalı Cephe Yazısı" },
      { img: "/images/kharft/b1-4.webp", label: "Kurumsal Kutu Harf Montajı" },
    ],
    metaDesc: "Osmaniye kutu harf tabela üretimi - LED aydınlatmalı paslanmaz çelik ve alüminyum kutu harf tabelalar. VİP Reklam Dekorasyon profesyonel tabela çözümleri.",
  },
  {
    slug: "totem-tabela",
    title: "Totem Tabela",
    shortTitle: "Totem Tabela",
    icon: "ri-layout-column-line",
    tagline: "Markanızı uzaktan görünür yapan dayanıklı ve prestijli totem çözümleri",
    heroImg: "/images/totemt/IMG_20201002_182719.webp",
    sideImg: "/images/totemt/t.webp",
    description: "AVM girişi, akaryakıt istasyonu, park alanı ve cadde cepheleri için ışıklı/ışıksız totem tabela tasarım, üretim ve montaj hizmeti sunuyoruz.",
    longDesc: "Totem tabelalar; işletmenizin konumunu uzaktan fark edilir hale getiren, kurumsal kimliğinizi güçlü biçimde yansıtan yüksek etkili dış mekan reklam ürünleridir. VİP Reklam Dekorasyon olarak tek yüzlü, çift yüzlü ve çok yüzlü totem sistemlerini proje sahasına uygun ölçü, zemin altyapısı ve rüzgar yükü hesaplarıyla planlıyoruz. Galvanizli çelik konstrüksiyon, dış hava koşullarına dayanıklı kaplama ve enerji verimli LED aydınlatma ile uzun ömürlü çözümler üretiyor; üretimden montaja kadar tüm süreci tek ekipte yönetiyoruz.",
    features: [
      { icon: "ri-arrow-up-circle-line", title: "Yüksek Görünürlük", desc: "Cadde ve ana yol akslarında uzaktan fark edilen büyük format çözümler" },
      { icon: "ri-sun-fill", title: "LED Aydınlatma", desc: "Gece-gündüz okunabilirlik sağlayan düşük tüketimli LED sistemler" },
      { icon: "ri-layout-2-line", title: "Tek/Çift Yüzlü Tasarım", desc: "Saha ihtiyacına göre tek, çift veya çok yüzlü gövde alternatifleri" },
      { icon: "ri-shield-check-line", title: "Dış Mekan Dayanımı", desc: "Rüzgar, yağmur ve UV etkilerine karşı dayanıklı malzeme yapısı" },
      { icon: "ri-map-pin-2-line", title: "Kurumsal Yönlendirme", desc: "AVM, kampüs, plaza ve tesis girişleri için yönlendirici totemler" },
      { icon: "ri-tools-line", title: "Uçtan Uca Montaj", desc: "Keşif, temel hazırlığı, ankraj ve montajın tek ekip tarafından yönetimi" },
    ],
    gallery: [
      { img: "/images/totemt/1.webp", label: "LED Aydınlatmalı Giriş Totemi", position: "center 35%" },
      { img: "/images/totemt/2.webp", label: "Cadde Tipi Çift Yüzlü Totem" },
      { img: "/images/totemt/3.webp", label: "Kurumsal Yönlendirme Totemi" },
    ],
    metaDesc: "Osmaniye totem tabela üretimi - LED ışıklı, dayanıklı totem tabela tasarım ve montaj hizmetleri. VİP Reklam Dekorasyon.",
  },
  {
    slug: "cafe-restorant-dekorasyon",
    title: "Cafe & Restorant Dekorasyon",
    shortTitle: "Cafe Dekorasyonu",
    icon: "ri-store-2-line",
    tagline: "Mekanınıza hayat veren özgün konsept dekorasyon projeleri",
    heroImg: "/images/dekorasyon/20240416_075742109_iOS.webp",
    sideImg: "/images/dekorasyon/IMG_20210914_184543.webp",
    description: "Konsept tasarımdan anahtar teslime, cafe ve restoranlarınıza özel iç mekan dekorasyon hizmetleri sunuyoruz.",
    longDesc: "VİP Reklam Dekorasyon olarak cafeleriniz, restoranlarınız ve işletmeleriniz için özgün konsept tasarım ve uygulama hizmetleri sunuyoruz. Ahşap, metal, taş ve bitkisel dekorasyonları harmanlayarak markanızın ruhunu yansıtan mekanlar yaratıyoruz. Tasarımdan üretime, montajdan teslime kadar tüm süreçleri biz yönetiyoruz.",
    features: [
      { icon: "ri-pencil-ruler-2-line", title: "3D Konsept Tasarım", desc: "Uygulamadan önce mekanınızı 3D olarak görselleştiriyoruz" },
      { icon: "ri-plant-line", title: "Dikey Bahçe & Yapay Bitki", desc: "Mekanınıza doğal atmosfer katan yeşil dekorasyon uygulamaları" },
      { icon: "ri-hammer-line", title: "Özel Mobilya & Aplik", desc: "Tasarıma özel üretim mobilya ve dekoratif aydınlatma" },
      { icon: "ri-image-line", title: "Duvar Grafik & Mural", desc: "Markanızı yansıtan büyük format duvar grafikleri" },
      { icon: "ri-archive-drawer-line", title: "Vitrin & Showcase", desc: "Ürün sergisi ve vitrin düzenleme çözümleri" },
      { icon: "ri-home-smile-line", title: "Tüm Mekanlar", desc: "Cafe, restoran, otel, ofis ve butik mağaza projeleri" },
    ],
    gallery: [
      { img: "/images/dekorasyon/20240416_075603470_iOS.webp", label: "Cafe İç Mekan Dekorasyonu" },
      { img: "/images/dekorasyon/IMG_20210814_180257.webp", label: "Restorant Oturma Alanı Tasarımı" },
      { img: "/images/dekorasyon/IMG_20211007_175750.webp", label: "Konsept Duvar ve Aydınlatma Uygulaması" },
    ],
    metaDesc: "Osmaniye cafe ve restorant dekorasyon - konsept tasarım, iç mekan uygulama, mobilya ve aydınlatma çözümleri. VİP Reklam Dekorasyon.",
  },
  {
    slug: "isikli-menu-board",
    title: "Işıklı Menü Board",
    shortTitle: "Menü Board",
    icon: "ri-lightbulb-flash-line",
    tagline: "Cafe ve restoranlar için dikkat çekici, okunaklı ve şık menü board çözümleri",
    heroImg: "/images/men/20190321_015941.webp",
    sideImg: "/images/men/20190318_223346.webp",
    description: "Işıklı ve ışıksız menü board tabela çözümleriyle ürünlerinizi net, estetik ve satış odaklı şekilde sunmanızı sağlıyoruz.",
    longDesc: "Menü board tabelalar, satış noktalarında müşteri karar sürecini hızlandıran en etkili tanıtım araçlarındandır. VİP Reklam Dekorasyon olarak işletmenize özel boyut, tipografi ve ışık yoğunluğunda menü board üretimi yapıyor; montaj ve güncelleme süreçlerinde pratik kullanım sağlayan çözümler sunuyoruz.",
    features: [
      { icon: "ri-lightbulb-line", title: "LED Arka Aydınlatma", desc: "Homojen ışık dağılımı ile yüksek okunabilirlik" },
      { icon: "ri-layout-grid-line", title: "Modüler Panel Yapısı", desc: "Kolay güncellenebilir menü alanı ve panel sistemi" },
      { icon: "ri-palette-line", title: "Kurumsal Tasarım", desc: "Markanıza uygun renk, çerçeve ve yazı karakteri seçenekleri" },
      { icon: "ri-store-2-line", title: "Sektöre Özel", desc: "Cafe, restorant, fast food ve pastane için uygun uygulamalar" },
      { icon: "ri-tools-line", title: "Profesyonel Montaj", desc: "Duvar, askı veya özel taşıyıcı sistemlerle kurulum" },
      { icon: "ri-leaf-line", title: "Enerji Tasarrufu", desc: "Düşük tüketimli LED altyapı ile uzun ömürlü kullanım" },
    ],
    gallery: [
      { img: "/images/men/20190321_015941.webp", label: "Işıklı Menü Board Uygulaması" },
      { img: "/images/men/20190318_223346.webp", label: "Restoran Menü Sunum Alanı" },
      { img: "/images/men/20190613_001641.webp", label: "Menü Board Cephe Görünümü" },
    ],
    metaDesc: "Osmaniye ışıklı menü board uygulamaları - cafe ve restoranlar için LED menü board tasarım, üretim ve montaj hizmeti.",
  },
  {
    slug: "anahtar-teslim-proje",
    title: "Anahtar Teslim Proje",
    shortTitle: "Anahtar Teslim",
    icon: "ri-key-2-line",
    tagline: "Tasarımdan montaja, tek noktadan tam çözüm deneyimi",
    heroImg: "/images/a/a-2.webp",
    sideImg: "/images/a/a.webp",
    description: "Tasarım, üretim, montaj ve bakım dahil tüm süreçleri tek elden yönetiyoruz. Zamandan ve maliyetten tasarruf edin.",
    longDesc: "VİP Reklam'ın anahtar teslim proje hizmeti; cephe kaplama, tabela, dekorasyon ve reklam uygulamalarını tek sözleşme altında baştan sona yönetmemizi kapsıyor. Tasarım aşamasından üretime, montajdan resmi teslime kadar her adımda yanınızdayız. Büyük ölçekli ticari projeler, mağaza açılışları ve bina yenilemeleri başlıca uzmanlık alanlarımız.",
    features: [
      { icon: "ri-pencil-ruler-2-line", title: "Proje Tasarımı", desc: "Konsept geliştirme, 3D görselleştirme ve teknik çizim" },
      { icon: "ri-tools-line", title: "Atölye Üretimi", desc: "Tüm ürünler kendi atölyemizde üretilir, fason yoktur" },
      { icon: "ri-team-line", title: "Uzman Montaj Ekibi", desc: "Deneyimli montaj ekibi ile hızlı ve güvenli uygulama" },
      { icon: "ri-clipboard-line", title: "Proje Yönetimi", desc: "Süreç boyunca tek iletişim noktası, tam koordinasyon" },
      { icon: "ri-time-line", title: "Söz Verilen Teslim", desc: "Belirlenen takvime tam uyum ve günlük ilerleme raporu" },
      { icon: "ri-customer-service-2-line", title: "Sonrası Destek", desc: "Teslim sonrası bakım, onarım ve teknik destek hizmetleri" },
    ],
    gallery: [
      { img: "/images/a/a.webp", label: "Anahtar Teslim Proje Uygulaması" },
      { img: "/images/a/a-2.webp", label: "Mağaza Açılış Projesi" },
      { img: "/images/a/a%20(2).webp", label: "Kurumsal Uygulama Detayı" },
    ],
    metaDesc: "Osmaniye anahtar teslim proje hizmetleri - cephe, tabela ve dekorasyon projelerinde tek elden tam çözüm. VİP Reklam Dekorasyon.",
  },
  {
    slug: "led-teknolojisi",
    title: "LED Teknolojisi",
    shortTitle: "LED Teknolojisi",
    icon: "ri-led-line",
    tagline: "Enerji verimli, uzun ömürlü ve dikkat çekici LED tabela çözümleri",
    heroImg: "/images/led/3.webp",
    heroPosition: "center 62%",
    sideImg: "/images/led/3.webp",
    description: "LED neon, RGB piksel panel, kontur aydınlatma ve dijital tabela sistemleriyle markanıza güçlü bir gece-gündüz görünürlüğü kazandırıyoruz.",
    longDesc: "LED teknolojisi, reklam ve yönlendirme sistemlerinde hem estetik hem de verimlilik sağlayan en önemli altyapıdır. VİP Reklam Dekorasyon olarak işletmenize özel LED neon uygulamaları, dış mekan dayanımlı modül sistemleri, RGB animasyon çözümleri ve dijital LED board projeleri geliştiriyoruz. Kullanılan LED bileşenlerinde düşük enerji tüketimi, yüksek ışık kalitesi ve uzun ömür önceliğiyle üretim yapıyor; keşif, üretim, montaj ve teknik destek süreçlerini tek merkezden yönetiyoruz.",
    features: [
      { icon: "ri-lightbulb-flash-line", title: "LED Neon Tabela", desc: "Özel tasarım, her renk ve şekilde LED neon tabelalar" },
      { icon: "ri-tv-line", title: "Dijital LED Board", desc: "Dinamik içerik görüntüleyen outdoor ve indoor LED ekranlar" },
      { icon: "ri-rainbow-line", title: "RGB Piksel Efekt", desc: "Renkli animasyonlu piksel tabela ve cephe sistemleri" },
      { icon: "ri-flashlight-line", title: "Kontur Aydınlatma", desc: "Bina konturunu belirginleştiren LED çerçeveleme sistemleri" },
      { icon: "ri-leaf-line", title: "Enerji Tasarrufu", desc: "Geleneksel neon\'a göre %80 daha az enerji tüketimi" },
      { icon: "ri-timer-line", title: "50.000 Saat Ömür", desc: "A+ kalite LED chip ile uzun ömürlü dayanıklı sistemler" },
    ],
    gallery: [
      { img: "/images/led/l-1.webp", label: "LED Neon Cephe Uygulaması" },
      { img: "/images/led/l-2.webp", label: "RGB Piksel LED Sistem" },
      { img: "/images/led/l-3.webp", label: "Dijital LED Board Kurulumu" },
    ],
    metaDesc: "Osmaniye LED tabela ve aydınlatma sistemleri - LED neon, dijital board ve RGB piksel çözümleri. VİP Reklam Dekorasyon.",
  },
  {
    slug: "matbaa-baski",
    title: "Matbaa / Baskı",
    shortTitle: "Matbaa & Baskı",
    icon: "ri-printer-line",
    tagline: "Geniş format baskıdan kurumsal baskı hizmetlerine tek adres",
    heroImg: "/images/mat/m-2.webp",
    sideImg: "/images/mat/m-2.webp",
    description: "Banner, branda, folyo, sticker ve geniş format baskı hizmetleriyle tüm tanıtım materyallerinizi üretiyoruz.",
    longDesc: "VİP Reklam Dekorasyon matbaa birimi; geniş format dijital baskı, branda, vinil banner, araç giydirme, folyo kaplama, sticker ve tabela yüzeyi baskısı başta olmak üzere kapsamlı baskı hizmetleri sunmaktadır. Solvent, UV ve eko-solvent baskı makinelerimizle yüksek çözünürlük ve renk doğruluğu garantisi veriyoruz.",
    features: [
      { icon: "ri-image-2-line", title: "Geniş Format Baskı", desc: "5m genişliğe kadar yüksek çözünürlüklü baskı kapasitesi" },
      { icon: "ri-flag-line", title: "Branda & Banner", desc: "İç ve dış mekan bannerları, branda ve flex baskı" },
      { icon: "ri-car-line", title: "Araç Giydirme", desc: "Araç kaplama, kısmi ve tam giydirme uygulamaları" },
      { icon: "ri-scissors-cut-line", title: "Folyo & Sticker", desc: "Kesim sticker, folyo kaplama ve dekoratif vinil uygulamaları" },
      { icon: "ri-file-paper-2-line", title: "Kurumsal Baskı", desc: "Katalog, broşür, kartvizit ve tanıtım materyalleri" },
      { icon: "ri-speed-line", title: "Hızlı Teslimat", desc: "Acil siparişlerde aynı gün teslimat imkanı" },
    ],
    gallery: [
      { img: "/images/mat/m-1.webp", label: "Kurumsal Branda Baskı Uygulaması" },
      { img: "/images/mat/m-3.webp", label: "Profesyonel Araç Giydirme Çalışması" },
      { img: "/images/mat/m-4.webp", label: "Özel Kesim Folyo & Sticker Uygulaması" },
    ],
    metaDesc: "Osmaniye geniş format baskı ve matbaa hizmetleri - banner, branda, sticker, araç giydirme ve folyo kaplama. VİP Reklam Dekorasyon.",
  },
  {
    slug: "grafik-tasarim",
    title: "Grafik Tasarım",
    shortTitle: "Grafik Tasarım",
    icon: "ri-palette-line",
    tagline: "Markanıza özel yaratıcı ve kurumsal tasarım çözümleri",
    heroImg: "/images/marketing-strategy-planning-strategy-concept.jpg",
    sideImg: "/images/marketing-strategy-planning-strategy-concept.jpg",
    description: "Logo, kurumsal kimlik, sosyal medya görselleri, menü tasarımları ve baskıya uygun yaratıcı tasarım hizmetleri sunuyoruz.",
    longDesc: "VİP Reklam Dekorasyon grafik tasarım birimi; markanızın görsel dilini güçlendirecek profesyonel çalışmalar üretir. Logo tasarımı, kartvizit, broşür, katalog, afiş, menü, kampanya postları ve dijital içerik tasarımları için hedef kitlenize uygun, modern ve akılda kalıcı tasarım çözümleri geliştiriyoruz.",
    features: [
      { icon: "ri-award-line", title: "Logo Tasarımı", desc: "Markanızı temsil eden özgün ve güçlü logo çalışmaları" },
      { icon: "ri-layout-grid-line", title: "Kurumsal Kimlik", desc: "Kartvizit, antetli kağıt, dosya ve marka dilini bütünleyen setler" },
      { icon: "ri-instagram-line", title: "Sosyal Medya Tasarımı", desc: "Instagram ve dijital platformlar için kampanya odaklı görseller" },
      { icon: "ri-file-list-3-line", title: "Menü & Katalog", desc: "Cafe/restoran menüleri, ürün katalogları ve sunum tasarımları" },
      { icon: "ri-printer-line", title: "Baskıya Uygun Çıkış", desc: "CMYK, bleed ve ölçü standartlarında baskıya hazır dosyalar" },
      { icon: "ri-time-line", title: "Hızlı Revize Süreci", desc: "Onay odaklı revize adımlarıyla kısa sürede net teslim" },
    ],
    gallery: [
      { img: "/images/mat/m-1.webp", label: "Kurumsal Kampanya Tasarımı" },
      { img: "/images/cafe/c (2).webp", label: "Menü Tasarımı & Sunum" },
      { img: "/images/57e4bf57c706f5f2f63ebf7595deb574-f02c7d1e.jpg", label: "Sosyal Medya Görsel Seti" },
    ],
    metaDesc: "Osmaniye grafik tasarım hizmetleri - logo, kurumsal kimlik, sosyal medya görselleri, menü ve katalog tasarımları. VİP Reklam Dekorasyon.",
  },
];

export default SERVICES_DATA;
